import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
  logined: false,
  account: undefined
};
const getters = {
  logined: function() { return state.logined; },
  account: function() { return state.account; }
};
const mutations = {
  SET_LOGINED: function(state, d) { state.logined = d; },
  SET_USER: function(state, d) { state.account = d; }
};
const actions = {
  setLogined: function(context, data) { context.commit('SET_LOGINED', data); },
  setUser: function(context, data) { context.commit('SET_USER', data); }
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/vuex/store.js